import { render, staticRenderFns } from "./content-panel.vue?vue&type=template&id=33ac3bc4&"
import script from "./content-panel.vue?vue&type=script&lang=js&"
export * from "./content-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports